import { css } from "@emotion/core"
import { theme } from "../constants"

export const largeLogoContainer = css`
  font-family: ${theme.fonts.primary};
  font-weight: ${theme.fontWeights.regular};
  font-size: ${theme.lineHeights[2]};
  line-height: ${theme.lineHeights[3]};
  color: ${theme.colors.text};
  white-space: nowrap;
`
export const largeImgLogo = css`
  margin-right: 20px;
  width: auto;
  max-width: 100%;
  max-height: 55px;
`
export const smallLogoContainer = css`
  font-family: ${theme.fonts.primary};
  font-weight: ${theme.fontWeights.regular};
  font-size: ${theme.fontSizes[11]};
  line-height: ${theme.lineHeights[2]};
  color: ${theme.colors.text};
  white-space: nowrap;
`
export const smallImgLogo = css`
  margin-right: 10px;
  width: auto;
  max-width: 100%;
  max-height: 35px;
`
export const logoContainerStyle = (size) => {
  if (size === "large")
    return css`
      ${largeLogoContainer};
    `

  return css`
    ${smallLogoContainer};
  `
}

export const imgLogo = (size) => {
  if (size === "large")
    return css`
      ${largeImgLogo}
    `

  return css`
    ${smallImgLogo}
  `
}

export const bgStyle = css`
  height: 50vh;
  width: 80vw;
  background: #493988;
  padding: 1em;
`
